import { useEffect, useRef, useState } from "react";
import { Column } from "primereact/column";
import { DataTable } from "primereact/datatable";
import { Dropdown } from "primereact/dropdown";
import { InputText } from "primereact/inputtext";
import { RadioButton } from "primereact/radiobutton";
import { Button } from "primereact/button";
import { getTodayDate } from "../helper/helperFunctions";
import { fetchUsersList, fetchVehicles } from "./fetchData";
import { Toast } from "primereact/toast";
import { convertDateToEpochUTC } from "../../../../helper/DateConverters";
import PhotoUpload from "./PhotoUpload/photoUpload";
import { showError, showSuccess } from "../../../../util/ShowStatus";
import axios from "../../../../util/axiosconfig";
import { InputNumber } from "primereact/inputnumber";
import { getErrorMessage } from "../../../../helper/getResponseMessage";
import { useNavigate } from "react-router-dom";
import { InputTextarea } from "primereact/inputtextarea";
import { ROLES } from "../../../../util/roleNameConstants";

const VehicleAssessment = () => {
  const toast = useRef<Toast>(null);
  const navigate = useNavigate();

  const [usersListLoading, setUsersListLoading] = useState<boolean>(false);
  const [vehicleListLoading, setVehicleListLoading] = useState<boolean>(false);
  const [formSubmitting, setFormSubmitting] = useState<boolean>(false);

  const [usersList, setUsersList] = useState<any>([]);
  const [vehiclesList, setVehiclesList] = useState<any>([]);
  // const [previousSelectedVehicle, setPreviousSelectedVehicle] =
  //   useState<any>(null);

  const [formValues, setFormValues] = useState<any>({
    date: convertDateToEpochUTC(new Date(new Date().setHours(0, 0, 0, 0))),
    driver: {
      userID: null,
      displayName: null,
    },
    vehicle: {
      vehicleID: null,
      registration_no: null,
      vehicleType: null,
      vehicleTypeID: null,
      isActive: null,
      make: null,
      model: null,
      mileage: null,
    },
    dailyShiftCheck: {
      checklist: [
        {
          label: "Horn Working",
          value: null,
          name: "hornWorking",
        },
        {
          label: "Seat belts working",
          value: null,
          name: "seatBeltsWorking",
        },
        {
          label: "Number plate",
          value: null,
          name: "numberPlate",
        },
        {
          label: "Lights working",
          value: null,
          name: "lightsWorking",
        },
        {
          label: "Wipes and spray functional",
          value: null,
          name: "wipesAndSpray",
        },
        {
          label: "Brakes and handbrake functional",
          value: null,
          name: "brakesAndHandbrake",
        },
        {
          label: "Bodywork in good condition and clean",
          value: null,
          name: "bodyworkCondition",
        },
        {
          label: "Tyre and wheel fixings including spare",
          value: null,
          name: "tyreAndWheelFixings",
        },
        {
          label: "Windows mirrors clean and not damaged",
          value: null,
          name: "windowsAndMirrors",
        },
        {
          label: "Engine oil coolant and fuel levels correct",
          value: null,
          name: "engineOilCoolantFuel",
        },
        {
          label:
            "Headlights, taillights, indicators and hazard lights functional",
          value: null,
          name: "headlightsTaillightsIndicators",
        },
        {
          label: "Have you reported all the defects?",
          value: null,
          name: "additionalDefects",
        },
      ],
    },
    additionalDefectComments: null,
    confirmRoadWorthy: {
      label:
        "I have carried out the daily vehicle inspection to the best of my ability and found the vehicle to be in a roadworthy and safe condition for use.",
      value: null,
      name: "confirmRoadWorthy",
    },
  });

  const [images, setImages] = useState<Record<string, File>>({});
  const [isUploadInProgress, setIsUploadInProgress] = useState<boolean>(false);
  const [fileValues, setFileValues] = useState<any[]>([]);
  const [timeStampLocationValues, setTimeStampLocationValues] = useState({
    locations: [],
    timeStamps: [],
  });

  const [selectedDriver, setSelectedDriver] = useState<any>(null);
  const [selectedVehicle, setSelectedVehicle] = useState<any>(null);

  useEffect(() => {
    fetchUsersList(
      setUsersList,
      setUsersListLoading,
      setSelectedDriver,
      setFormValues,
      setSelectedVehicle,
      toast
    );
    fetchVehicles(setVehiclesList, setVehicleListLoading, toast);
    // if (!localStorage.roleName.includes(ROLES.HANDS_ADMIN)) {
    // Optionally, set default driver here if needed, e.g. first user in list after fetch
    // setSelectedDriver(usersList[0]);
    // setFormValues({
    //   ...formValues,
    //   driver: {
    //     userID: usersList[0]?.userID ?? null,
    //     displayName: usersList[0]?.displayName ?? null,
    //   },
    // });
    // }
  }, []);

  const validateForm = () => {
    if (!formValues.driver.userID) {
      showError("Please select a driver.", toast);
      return false;
    }
    if (!formValues.vehicle.vehicleID) {
      showError("Please select a vehicle.", toast);
      return false;
    }
    if (!formValues.vehicle.mileage) {
      showError("Please enter the vehicle mileage.", toast);
      return false;
    }
    const hasInvalidChecklist = formValues.dailyShiftCheck.checklist.some(
      (item: any) => item.value === null
    );
    if (hasInvalidChecklist) {
      showError("All checklist items must be selected.", toast);
      return false;
    }
    if (
      formValues.dailyShiftCheck.checklist.some(
        (item: any) => item.name === "additionalDefects" && item.value === false
      )
    ) {
      if (
        !fileValues.some(
          (file) =>
            file.photoKey && file.photoKey.toLowerCase().includes("defect")
        )
      ) {
        showError("Please upload at least one defect photograph.", toast);
        return false;
      }
    }
    // Only require comments if "additionalDefects" is selected as false
    if (
      formValues.dailyShiftCheck.checklist.some(
        (item: any) => item.name === "additionalDefects" && item.value === false
      )
    ) {
      if (
        !formValues?.additionalDefectComments ||
        formValues?.additionalDefectComments.trim() === ""
      ) {
        showError("Please provide comments for additional defects.", toast);
        return false;
      }
    }
    // if (
    //   !formValues?.additionalDefectComments ||
    //   formValues?.additionalDefectComments.trim() === ""
    // ) {
    //   showError("Please provide comments for additional defects.", toast);
    //   return false;
    // }
    // if (
    //   !fileValues.some(
    //     (file) =>
    //       file.photoKey && file.photoKey.toLowerCase().includes("front-driver")
    //   )
    // ) {
    //   showError("Please upload the Front Driver photograph.", toast);
    //   return false;
    // }
    // if (
    //   !fileValues.some(
    //     (file) =>
    //       file.photoKey &&
    //       file.photoKey.toLowerCase().includes("front-passenger")
    //   )
    // ) {
    //   showError("Please upload the Front Passenger photograph.", toast);
    //   return false;
    // }
    if (
      !fileValues.some(
        (file) =>
          file.photoKey && file.photoKey.toLowerCase().includes("dashboard")
      )
    ) {
      showError("Please upload the Dashboard photograph.", toast);
      return false;
    }
    // if (
    //   !fileValues.some(
    //     (file) =>
    //       file.photoKey &&
    //       file.photoKey.toLowerCase().includes("vehicle-front-cabin-interior")
    //   )
    // ) {
    //   showError(
    //     "Please upload the Vehicle Front Cabin Interior photograph.",
    //     toast
    //   );
    //   return false;
    // }
    // if (
    //   !fileValues.some(
    //     (file) =>
    //       file.photoKey &&
    //       file.photoKey.toLowerCase().includes("vehicle-backside-interior")
    //   )
    // ) {
    //   showError(
    //     "Please upload the Vehicle Backside Interior photograph.",
    //     toast
    //   );
    //   return false;
    // }
    if (
      formValues.confirmRoadWorthy.value === null ||
      formValues.confirmRoadWorthy.value === undefined
    ) {
      showError("Please confirm if the vehicle is roadworthy.", toast);
      return false;
    }
    return true;
  };

  const handleSave = async () => {
    try {
      if (!validateForm()) {
        return;
      }
      setFormSubmitting(true);
      setIsUploadInProgress(true);
      // Prepare FormData
      const formData = new FormData();
      const photosArray: File[] = [];

      fileValues.forEach((photoItem: any) => {
        if (photoItem?.photoKey && photoItem?.file) {
          const fileName = `${photoItem.photoKey}.png`;
          const dataURL = new Blob([photoItem.file], {
            type: "image/png",
          });
          const photoFile = new File([dataURL], fileName, {
            type: "image/png",
          });
          photosArray.push(photoFile);
        }
      });

      photosArray.forEach((file, index) => {
        if (file.name.toLowerCase().includes("defect-")) {
          formData.append("defectImages", file);
        } else {
          formData.append("vehicleImages", file);
        }
      });

      formData.append("formJson", JSON.stringify(formValues));
      formData.append(
        "timeStampLocationJson",
        JSON.stringify(timeStampLocationValues)
      );
      formData.append("isWeb", "true");

      const response = await axios.post(
        "health-and-safety/vehicle-asset-form",
        formData,
        {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        }
      );
      setFormSubmitting(false);
      showSuccess(response.data.Message, toast);
      navigate("/layout/leak-detection/vehicle-assessment-list");
    } catch (error) {
      const errorMessage = getErrorMessage(error);
      setFormSubmitting(false);
      showError(errorMessage, toast);
    }
  };

  const isDisabled = isUploadInProgress || formSubmitting;

  return (
    <>
      <Toast ref={toast} />
      <div className="tw-border-solid tw-border tw-border-[#E2E2e2] tw-rounded-lg tw-relative tw-bg-white ">
        <div className="tw-bg-[#F8FAFC] tw-p-4 tw-rounded-t-lg tw-border-b-[1px] tw-border-[#E2E8F0] tw-flex tw-justify-between tw-items-center">
          <h2 className="tw-text-lg sm:tw-text-xl xl:tw-text-2xl tw-font-semibold tw-text-[#101828]">
            Vehicle Asset Check
          </h2>
        </div>
        <div>
          <div className="tw-p-2 sm:tw-p-4">
            {/* basic details */}
            <div className="tw-border-b-[1px] tw-border-[#E2E8F0] tw-mb-2 sm:tw-mb-4">
              <h2 className="tw-text-base sm:tw-text-lg tw-font-semibold tw-text-[#101828]">
                Basic Details
              </h2>
            </div>
            <div className="tw-grid tw-grid-cols-1 xl:tw-grid-cols-2 2xl:tw-grid-cols-3 tw-gap-3 tw-w-full">
              <div className="tw-flex tw-flex-col tw-gap-1 tw-items-start tw-justify-start">
                <label className="leak-label" htmlFor="teamMember1">
                  Date
                </label>
                <InputText
                  type="text"
                  className="tw-pl-2 tw-border tw-border-gray-300 tw-rounded-md tw-text-[#667085] tw-h-11 tw-w-full"
                  value={getTodayDate() ?? ""}
                  readOnly
                  disabled={isDisabled}
                />
              </div>
              <div className="tw-flex tw-flex-col tw-gap-1 tw-w-full ">
                <label className="leak-label" htmlFor="teamMember1">
                  Driver Name
                </label>
                {localStorage.roleName.includes(ROLES.HANDS_ADMIN) ? (
                  <Dropdown
                    id="driverName"
                    optionLabel="displayName"
                    value={selectedDriver}
                    loading={usersListLoading}
                    onChange={(e) => {
                      setSelectedDriver(e.value);
                      setFormValues({
                        ...formValues,
                        driver: {
                          userID: e.value.userID,
                          displayName: e.value.displayName,
                        },
                      });
                    }}
                    readOnly={
                      !localStorage.roleName.includes(ROLES.HANDS_ADMIN)
                    }
                    placeholder="Select Driver"
                    options={usersList}
                    filter
                    className="custome-dropdown !tw-w-full"
                    disabled={isDisabled}
                  />
                ) : (
                  <InputText
                    type="text"
                    className="tw-pl-2 tw-border tw-border-gray-300 tw-rounded-md tw-text-[#667085] tw-h-11 tw-w-full"
                    readOnly
                    value={selectedDriver?.displayName || ""}
                    disabled={isDisabled}
                  />
                )}
              </div>
              <div className="tw-flex tw-flex-col tw-gap-1 tw-w-full">
                <label className="leak-label" htmlFor="teamMember1">
                  Vehicle Registration
                </label>
                <Dropdown
                  id="vehcileRegistration"
                  optionLabel="registration_no"
                  placeholder="Select Vehicle"
                  options={vehiclesList}
                  value={selectedVehicle}
                  loading={vehicleListLoading}
                  onChange={(e) => {
                    setSelectedVehicle(e.value);
                    setFormValues({
                      ...formValues,
                      vehicle: {
                        ...formValues.vehicle,
                        vehicleID: e.value.vehicleID,
                        registration_no: e.value.registration_no,
                        vehicleType: e.value.vehicleType,
                        vehicleTypeID: e.value.vehicleTypeID,
                        capacity: e.value.capacity,
                        make: e.value.make ? e.value.make : "N/A",
                        model: e.value.model ? e.value.model : "N/A",
                        isActive: e.value.isActive,
                      },
                    });
                  }}
                  filter
                  className="custome-dropdown !tw-w-full"
                  disabled={isDisabled}
                />
              </div>
              <div className="tw-flex tw-flex-col tw-gap-1 tw-items-start tw-justify-start tw-w-full">
                <label className="leak-label" htmlFor="teamMember1">
                  Make
                </label>
                <InputText
                  type="text"
                  className="tw-pl-2 tw-border tw-border-gray-300 tw-rounded-md tw-text-[#667085] tw-h-11 tw-w-full"
                  readOnly
                  value={formValues.vehicle.make || ""}
                  onChange={(e) =>
                    setFormValues((prev: any) => ({
                      ...prev,
                      vehicle: {
                        ...prev.vehicle,
                        make: e.target.value,
                      },
                    }))
                  }
                  disabled={isDisabled}
                />
              </div>
              <div className="tw-flex tw-flex-col tw-gap-1 tw-items-start tw-justify-start tw-w-full">
                <label className="leak-label" htmlFor="teamMember1">
                  Model
                </label>
                <InputText
                  type="text"
                  className="tw-pl-2 tw-border tw-border-gray-300 tw-rounded-md tw-text-[#667085] tw-h-11 tw-w-full"
                  readOnly
                  value={formValues.vehicle.model || ""}
                  onChange={(e) =>
                    setFormValues((prev: any) => ({
                      ...prev,
                      vehicle: {
                        ...prev.vehicle,
                        model: e.target.value,
                      },
                    }))
                  }
                  disabled={isDisabled}
                />
              </div>
              <div className="tw-flex tw-flex-col tw-gap-1 tw-w-full">
                <label className="leak-label" htmlFor="teamMember1">
                  Insert Mileage
                </label>
                <InputNumber
                  value={formValues?.vehicle?.mileage ?? ""}
                  onChange={(e) =>
                    setFormValues((prev: any) => ({
                      ...prev,
                      vehicle: {
                        ...prev.vehicle,
                        mileage: e.value,
                      },
                    }))
                  }
                  min={0}
                  // max={9999}
                  onKeyDown={(e) => {
                    if (
                      e.key === "-" ||
                      e.key === "e" ||
                      e.key === "+" ||
                      e.key === "ArrowUp" ||
                      e.key === "ArrowDown"
                    ) {
                      e.preventDefault();
                    }
                  }}
                  className="tw-pl-2 tw-border tw-border-gray-300 tw-rounded-md tw-text-[#667085] tw-h-11 tw-w-full"
                  disabled={isDisabled}
                />
              </div>
            </div>

            {/* daily shift check */}
            <div className="tw-p-2 sm:tw-p-4 tw-border-b-[1px] tw-border-[#E2E8F0] tw-mt-4">
              <h2 className="tw-text-base sm:tw-text-lg tw-font-semibold tw-text-[#101828]">
                Daily/Shift Check
              </h2>
            </div>
            <div className="tw-w-full tw-my-4 tw-overflow-x-auto">
              <div className="tw-min-w-[600px]">
                <DataTable
                  className="tw-w-full custome-leak-detection tw-text-black"
                  showGridlines
                  value={formValues?.dailyShiftCheck?.checklist}
                >
                  <Column
                    field="label"
                    header="Items"
                    className="tw-text-black tw-font-medium responsive-columns"
                  />
                  <Column
                    header="Yes"
                    className="lg:tw-w-[100px] tw-w-[80px]"
                    body={(rowData, { rowIndex }) => (
                      <RadioButton
                        inputId={`pass${rowIndex}`}
                        name={`status${rowIndex}`}
                        checked={
                          formValues?.dailyShiftCheck?.checklist[rowIndex]
                            .value === true
                        }
                        disabled={isDisabled}
                        onChange={() =>
                          setFormValues((prev: any) => ({
                            ...prev,
                            dailyShiftCheck: {
                              ...prev.dailyShiftCheck,
                              checklist: prev.dailyShiftCheck.checklist.map(
                                (item: any, index: number) => {
                                  if (index === rowIndex) {
                                    return { ...item, value: true };
                                  }
                                  return item;
                                }
                              ),
                            },
                          }))
                        }
                      />
                    )}
                  />
                  <Column
                    header="No"
                    className="lg:tw-w-[100px] tw-w-[80px]"
                    body={(rowData, { rowIndex }) => (
                      <RadioButton
                        inputId={`fail${rowIndex}`}
                        name={`status${rowIndex}`}
                        checked={
                          formValues?.dailyShiftCheck?.checklist[rowIndex]
                            .value === false
                        }
                        disabled={isDisabled}
                        onChange={() => {
                          const isAdditionalDefects =
                            formValues?.dailyShiftCheck?.checklist[rowIndex]
                              .name === "additionalDefects";

                          setFormValues((prev: any) => ({
                            ...prev,
                            dailyShiftCheck: {
                              ...prev.dailyShiftCheck,
                              checklist: prev.dailyShiftCheck.checklist.map(
                                (item: any, index: number) => {
                                  if (index === rowIndex) {
                                    return { ...item, value: false };
                                  }
                                  return item;
                                }
                              ),
                            },
                          }));

                          if (isAdditionalDefects) {
                            setImages((prevImages) => {
                              const newImages = { ...prevImages };
                              const filteredImages = Object.fromEntries(
                                Object.entries(newImages).filter(
                                  ([key]) =>
                                    !key.startsWith("photograph-") &&
                                    !key.startsWith("defect-")
                                )
                              );
                              return filteredImages;
                            });

                            setFileValues((prev) =>
                              prev.filter(
                                (item) =>
                                  !item.photoKey.startsWith("photograph-") &&
                                  !item.photoKey.startsWith("defect-")
                              )
                            );
                            setFormValues((prev: any) => ({
                              ...prev,
                              additionalDefectComments: null,
                            }));
                          }
                        }}
                      />
                    )}
                  />
                </DataTable>
              </div>
            </div>

            {/* Defect Photographs */}
            {formValues?.dailyShiftCheck?.checklist?.find(
              (checklist: any) => checklist.name === "additionalDefects"
            ).value === false && (
              <div>
                <div className="tw-p-2 sm:tw-p-4 tw-border-b-[1px] tw-border-[#E2E8F0]">
                  <h2 className="tw-text-base sm:tw-text-lg tw-font-semibold tw-text-[#101828]">
                    Defect Photographs
                  </h2>
                </div>
                <div className="tw-w-full tw-my-4 tw-grid tw-grid-cols-1 sm:tw-grid-cols-2 lg:tw-grid-cols-4 tw-gap-4">
                  <PhotoUpload
                    label="Defect 1"
                    name="Defect 1"
                    images={images}
                    isUploadInProgress={isUploadInProgress}
                    setIsUploadInProgress={setIsUploadInProgress}
                    setImages={setImages}
                    fileValues={fileValues}
                    setFileValues={setFileValues}
                    timeStampLocationValues={timeStampLocationValues}
                    setTimeStampLocationValues={setTimeStampLocationValues}
                    classname="tw-w-full"
                  />
                  <PhotoUpload
                    label="Defect 2"
                    name="Defect 2"
                    images={images}
                    isUploadInProgress={isUploadInProgress}
                    setIsUploadInProgress={setIsUploadInProgress}
                    setImages={setImages}
                    fileValues={fileValues}
                    setFileValues={setFileValues}
                    timeStampLocationValues={timeStampLocationValues}
                    setTimeStampLocationValues={setTimeStampLocationValues}
                    classname="tw-w-full"
                  />
                  <PhotoUpload
                    label="Defect 3"
                    name="Defect 3"
                    images={images}
                    isUploadInProgress={isUploadInProgress}
                    setIsUploadInProgress={setIsUploadInProgress}
                    setImages={setImages}
                    fileValues={fileValues}
                    setFileValues={setFileValues}
                    timeStampLocationValues={timeStampLocationValues}
                    setTimeStampLocationValues={setTimeStampLocationValues}
                    classname="tw-w-full"
                  />
                  <PhotoUpload
                    label="Defect 4"
                    name="Defect 4"
                    images={images}
                    isUploadInProgress={isUploadInProgress}
                    setIsUploadInProgress={setIsUploadInProgress}
                    setImages={setImages}
                    fileValues={fileValues}
                    setFileValues={setFileValues}
                    timeStampLocationValues={timeStampLocationValues}
                    setTimeStampLocationValues={setTimeStampLocationValues}
                    classname="tw-w-full"
                  />
                </div>
                <div className="tw-mt-4">
                  <span className="leak-label tw-text-[#5B5B5B] tw-text-sm tw-font-semibold">
                    Additional comments if any:-
                  </span>
                  <InputTextarea
                    value={formValues?.additionalDefectComments ?? ""}
                    onChange={(e) => {
                      setFormValues((prev: any) => ({
                        ...prev,
                        additionalDefectComments: e.target.value,
                      }));
                    }}
                    disabled={isUploadInProgress}
                    className="tw-w-full tw-mt-2"
                  />
                </div>
              </div>
            )}

            {/* Vehicle Photographs */}
            <div className="tw-p-2 sm:tw-p-4 tw-border-b-[1px] tw-border-[#E2E8F0]">
              <h2 className="tw-text-base sm:tw-text-lg tw-font-semibold tw-text-[#101828]">
                Vehicle Photographs
              </h2>
            </div>
            <div className="tw-w-full tw-my-4 tw-grid tw-grid-cols-1 sm:tw-grid-cols-2 lg:tw-grid-cols-3 xl:tw-grid-cols-5 tw-gap-4">
              <PhotoUpload
                label="Exterior - Front Driver Side"
                name="Front Driver"
                images={images}
                isUploadInProgress={isUploadInProgress}
                setIsUploadInProgress={setIsUploadInProgress}
                setImages={setImages}
                fileValues={fileValues}
                setFileValues={setFileValues}
                timeStampLocationValues={timeStampLocationValues}
                setTimeStampLocationValues={setTimeStampLocationValues}
                classname="tw-w-full"
              />
              <PhotoUpload
                label="Exterior - Front Passenger Side"
                name="Front Passenger"
                images={images}
                isUploadInProgress={isUploadInProgress}
                setIsUploadInProgress={setIsUploadInProgress}
                setImages={setImages}
                fileValues={fileValues}
                setFileValues={setFileValues}
                timeStampLocationValues={timeStampLocationValues}
                setTimeStampLocationValues={setTimeStampLocationValues}
                classname="tw-w-full"
              />
              <PhotoUpload
                label="Dashboard"
                name="Dashboard"
                images={images}
                isUploadInProgress={isUploadInProgress}
                setIsUploadInProgress={setIsUploadInProgress}
                setImages={setImages}
                fileValues={fileValues}
                setFileValues={setFileValues}
                timeStampLocationValues={timeStampLocationValues}
                setTimeStampLocationValues={setTimeStampLocationValues}
                classname="tw-w-full"
              />
              <PhotoUpload
                label="Vehicle Front Cabin Interior"
                name="Vehicle Front Cabin Interior"
                images={images}
                isUploadInProgress={isUploadInProgress}
                setIsUploadInProgress={setIsUploadInProgress}
                setImages={setImages}
                fileValues={fileValues}
                setFileValues={setFileValues}
                timeStampLocationValues={timeStampLocationValues}
                setTimeStampLocationValues={setTimeStampLocationValues}
                classname="tw-w-full"
              />
              <PhotoUpload
                label="Vehicle Backside Interior"
                name="Vehicle Backside Interior"
                images={images}
                isUploadInProgress={isUploadInProgress}
                setIsUploadInProgress={setIsUploadInProgress}
                setImages={setImages}
                fileValues={fileValues}
                setFileValues={setFileValues}
                timeStampLocationValues={timeStampLocationValues}
                setTimeStampLocationValues={setTimeStampLocationValues}
                classname="tw-w-full"
              />
            </div>

            <div className="tw-py-4 tw-flex tw-justify-between tw-gap-3 tw-items-start  tw-px-2">
              <div className="tw-text-sm sm:tw-text-base">
                {formValues?.confirmRoadWorthy?.label}
              </div>
              <div className="tw-flex tw-gap-4 tw-items-center tw-mr-4">
                <div className="tw-flex tw-gap-1 tw-items-center">
                  <RadioButton
                    inputId="yes"
                    value="confirm"
                    checked={
                      formValues?.confirmRoadWorthy.value === true
                        ? true
                        : false
                    }
                    onChange={() =>
                      setFormValues((prev: any) => ({
                        ...prev,
                        confirmRoadWorthy: {
                          ...prev.confirmRoadWorthy,
                          value: true,
                        },
                      }))
                    }
                    disabled={isDisabled}
                    name="confirm"
                  />
                  <label htmlFor="yes">Yes</label>
                </div>
                <div className="tw-flex tw-gap-1 tw-items-center">
                  <RadioButton
                    inputId="no"
                    value="notconfirm"
                    checked={
                      formValues?.confirmRoadWorthy.value === false
                        ? true
                        : false
                    }
                    onChange={() =>
                      setFormValues((prev: any) => ({
                        ...prev,
                        confirmRoadWorthy: {
                          ...prev.confirmRoadWorthy,
                          value: false,
                        },
                      }))
                    }
                    disabled={isDisabled}
                    name="notconfirm"
                  />
                  <label htmlFor="no">No</label>
                </div>
              </div>
            </div>
          </div>

          <div className="tw-flex tw-justify-end tw-items-center tw-p-4 tw-gap-2 tw-border-t-[1px] tw-border-[#E2E8F0]">
            <Button
              className="tw-flex tw-px-3 focus:tw-shadow-none tw-py-2 tw-rounded tw-bg-primary tw-border-primary tw-text-white tw-font-medium tw-text-sm sm:tw-text-base"
              label={`${formSubmitting ? "Saving..." : "Save"}`}
              disabled={isDisabled}
              loading={formSubmitting}
              onClick={handleSave}
            />
          </div>
        </div>
      </div>
    </>
  );
};

export default VehicleAssessment;
